import { createSelector } from "reselect";
import { RootState } from "../../rootReducer";

export const selectSigners = createSelector(
  [(store: RootState) => store.documentSignerShow.signers],
  (data) => data
);
